import { Typography, Tag } from 'antd';
import './../../styles/components/MarketPlace/JobListings.scss';
import React, { useEffect, useState } from 'react';
import { getClientIcon } from '../../utils/MarketplaceUtils';
import { jobDistance } from '../../constants/MarketplaceConstants';

const { Text } = Typography;

function ClientJobHeader({jobData, callback=null}) {
  const [clientIcon, setClientIcon] = useState("");
  const jobNature = jobData?.jobPreference === 'Both Full time and Part time' ? 'Full/Part Time': jobData?.jobPreference;


  useEffect(() => {
    setClientIcon(getClientIcon(jobData.companyName));
  }, [jobData]);

  const triggerCallback = () => {
    if (callback) callback();
  }
  
  return (
    <div className="job-header" onClick={()=> triggerCallback()}>
        <div className="client-icon">
        <img src={clientIcon} alt={jobData.companyName} style={{height:'50px'}}/>
        </div>
        <div className="client-details">
        <Text className="client-heading">
            {
            jobData.displayName ? jobData.displayName?.charAt(0).toUpperCase() + jobData.displayName?.slice(1): 
            jobData.clientName?.charAt(0).toUpperCase() + jobData.clientName?.slice(1)
            }
            <Tag className='job-type-tag'> {jobNature}</Tag>
        </Text>
        <Text className='client-type'>{jobData.jobType} Partner</Text>
        {
          (!jobData?.scheduledInterviewId || jobData?.isNonUnique) && jobDistance[jobData.companyName.toLowerCase()]?  (
            <Text className='client-distance'>Less than {jobDistance[jobData.companyName.toLowerCase()]} kms to Office</Text>

          ):null
        }
        </div>
    </div>
  )
}

export default ClientJobHeader
